import React, { useState, useEffect } from "react";
import Header from "../layout/Header";
import Sidebar from "../layout/Sidebar";
import { Spin } from "antd";
import Strings from "../constants/Strings";
import Bridge from "../constants/Bridge";
import $ from "jquery";

const ConsortiaKnowledgebase = () => {
  const [loading, setLoading] = useState(false);
  const [list, setList] = useState(false);

  // on load component function
  useEffect(() => {
    if ($(window).width() < 600) {
      $("#sidebar").removeClass("show-sidebar").addClass("hide-sidebar");
    } else {
      $("#sidebar").removeClass("hide-sidebar").addClass("show-sidebar");
    }
    Bridge.audit_logs.view_consortia_workspace();
    get_list();
  }, [0]);
  const get_list = () => {
    setLoading(true);
    Bridge.get_consortia_workspace_list().then((result) => {
      console.log("result", result);
      if (result.status == 1) {
        setList(result.data);
        setLoading(false);
      } else {
        setLoading(false);
      }
    });
  };
  return (
    <div className="cons-knowledge-page">
      <div>
        <Header />
        <div className="row">
          <Sidebar />
          <div
            className="col-lg-10 main_content_right_side"
            style={{
              minHeight: "100vh",
              paddingLeft: "32px",
              paddingRight: "30px",
              marginLeft: "auto",
              backgroundColor: "#F5F5F5",
            }}
          >
            <Spin spinning={loading}>
              <div
                className="main-section dashboard"
                style={{ marginTop: 105 }}
              >
                <div>
                  <p
                    style={{
                      position: "relative",
                      fontSize: 32,
                      fontFamily: "Open Sans",
                      fontWeight: "bold",
                      color: "#1A4F83",
                      textAlign: "start",
                    }}
                    className="mb-4 mt-4"
                  >
                    {Strings.consortiaKnowledgebase}
                  </p>
                  <p
                    style={{
                      position: "relative",
                      fontSize: 20,
                      fontFamily: "Open Sans",
                      fontWeight: "bold",
                      color: "#1A4F83",
                      textAlign: "start",
                    }}
                    className="mb-4"
                  >
                    Consortia Projects
                  </p>
                  <div className="consortia-knowledge-list">
                    {/* One  */}
                    {/* <div
                      className="row text-left content"
                      style={{ marginBottom: 70 }}
                    >
                      <div className="col-lg-12">
                        <h5 className="mb-3">
                          EverythingALS Roundtable & Work Stream Initiatives
                          Slides | September 9th, 2024
                        </h5>
                        <div className="row">
                          <div className="col-lg-4">
                            <img
                              src="./assets/img/knowledgebase/roundable.png"
                              style={{ width: "100%" }}
                            />
                          </div>
                          <div className="col-lg-8">
                            <p
                              className="mt-2 mb-2"
                              style={{
                                fontSize: 19,
                                fontWeight: 600,
                              }}
                            >
                              Download Presentation:
                            </p>
                            <div style={{ cursor: "pointer" }}>
                              <a
                                href="./assets/documents/09002024_Roundtable.pdf"
                                target="_blank"
                              >
                                <img
                                  src="./assets/img/knowledgebase/download-pdf.png"
                                  style={{
                                    width: 60,
                                    position: "relative",
                                    left: -8,
                                  }}
                                />
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div> */}
                    {/* Two  */}
                    <Spin spinning={loading}>
                      {list.length > 0 &&
                        list.map((item, index) => {
                          return (
                            <div
                              className="row text-left content"
                              key={index}
                              style={{ marginBottom: 40 }}
                            >
                              <div className="col-lg-12">
                                <h5 className="mb-3">{item.title}</h5>
                                <div className="row">
                                  <div className="col-lg-4">
                                    <img
                                      src={item.poster_image}
                                      style={{ width: "100%" }}
                                    />
                                  </div>
                                  <div className="col-lg-8">
                                    <p
                                      className="mt-2 mb-2"
                                      style={{
                                        fontSize: 19,
                                        fontWeight: 600,
                                      }}
                                    >
                                      {/* Current White Paper Draft: */}
                                      Download File
                                    </p>
                                    <div style={{ cursor: "pointer" }}>
                                      <a
                                        href={item.pdf_document}
                                        target="_blank"
                                      >
                                        <img
                                          src="./assets/img/knowledgebase/download-pdf.png"
                                          style={{
                                            width: 60,
                                            position: "relative",
                                            left: -8,
                                          }}
                                        />
                                      </a>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                    </Spin>
                  </div>
                </div>
              </div>
            </Spin>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConsortiaKnowledgebase;
